import { userAnalytics } from 'api';

export const LOG_EVENT = 'LOG_EVENT';
export const LOGGED_EVENT = 'LOGGED_EVENT';
export const ONBOARDING_SHOWN = 'ONBOARDING_SHOWN';

export const logEvent = event => (dispatch) => {
  dispatch({ type: LOG_EVENT, event });
  const fullEvent = { ...event, product: 'blueprint', version: 2 };

  return userAnalytics.log(fullEvent).end(err => dispatch({
    type: LOGGED_EVENT,
    status: err ? 'error' : 'success',
  }));
};

export const displayOnboardingModal = () => dispatch => userAnalytics.getEvents({
  event_type: ['page_view'],
  version: 2,
  product: 'blueprint',
  page_size: 2,
  page_num: 1,
}).end((err, response) => {
  if (response && response.body) {
    const results = response.body.resources;
    if (!err && results && (results.length === 0 || results.length === 1)) {
      dispatch({ type: ONBOARDING_SHOWN });
    }
  }
});
